import request from '../../untils/request';

export function selectList(data) {
	return request({
		url: '/concentrator/getConcentrator',
		method: 'get',
		params: data,
	});
}

export function save(data) {
	return request({
		url: '/concentrator/addConcentrator',
		method: 'post',
		data: data,
	});
}

export function modify(data) {
	return request({
		url: '/concentrator/modifyConcentrator',
		method: 'post',
		data: data,
	});
}

export function remove(param) {
	return request({
		url: '/concentrator/deleteConcentrator',
		method: 'get',
		params: {
			id: param
		},
	});
}



// 获取路径
export function getPath(data) {
	return request({
		url: '/basicExcelTemplate/getPath',
		method: 'get',
		params: data,
	});
}

// 模板下载
export function load(data) {
	return request({
		url: '/file/load',
		method: 'get',
		params: data,
		responseType: 'arraybuffer',
	});
}
